<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/bruno-giacosa')">Bruno Giacosa
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/cantina-roberto-voerzio')">Cantina Roberto
                        Voerzio
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/conterno-fantino')">Conterno Fantino
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/g-d-vajra')">G. D. Vajra
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/gaja')">Gaja
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/giacomo-conterno')">Giacomo Conterno
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/giuseppe-mascarello-e-figlio')">Giuseppe
                        Mascarello e Figlio
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/massolino')">Massolino
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/poderi-aldo-conterno')">Poderi Aldo Conterno
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/roagna')">Roagna
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/tenuta-la-giustiniana')">Tenuta La
                        Giustiniana
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/vigne-marina-coppi')">Vigne Marina Coppi
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/argentina')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Piedmont</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Quando si parla di vini rossi italiani e delle loro regioni di produzione, sarebbe impossibile non farlo
                        menzione del Piemonte. A due passi dal confine francese, il Piemonte si trova ai piedi delle Alpi e produce vini di grande gusto; entrambi di grande corpo e superbamente profumati. Le regioni principali sono ovviamente Barolo e Barbaresco e l'uva re
                        ecco senza dubbio il Nebbiolo. Alcuni bianchi, in particolare il sempre più di moda Gavi (made
                        con uve Cortese) stanno dando del filo da torcere ai rossi. Rendendosi conto che la gente voleva
                        vini da invecchiamento e da investimento (oltre che di immediata beva), prodotti da molti viticoltori di Barolo
                        il passaggio all'affinamento in botti di rovere francese. Ciò ha spinto l'età a circa 20 anni per alcuni
                        dei vini di altissima qualità. Un altro cambiamento che i vini del Piemonte hanno visto è il graduale passaggio da
                        100% singolo vigneto a taglio; non è raro trovare Nebbiolo in uvaggio con Barbera,
                        Merlot, Cabernet o anche Syrah.
                        <br><br>
                        Anche se spesso accomunati, Barolo e Barbaresco mostrano grandi differenze. Barolo, il
                        il cosiddetto “vino dei re e re dei vini” è una grande bestia di vino. Portando il peso di 150
                        anni di storia con esso, i Barolo Riserva richiedono un minimo di cinque anni in legno e bottiglia
                        prima del rilascio, sono vellutati ma sorprendentemente magri e sono probabilmente i più famosi d'Italia
                        esportare. Il Barbaresco invece è più leggero, più precoce a maturare (appena quattro anni in botte
                        o botti prima del rilascio) e un po' più facilmente nel bicchiere. Perché entrambe le regioni sono così vicine
                        prossimità, la topografia del suolo è molto simile. Entrambi hanno prodotto annate eccellenti da allora
                        la fine degli anni '90 e bar, 2002, quasi tutti sono vincitori. Se dovessimo scegliere il nostro preferito
                        tuttavia sarebbe senza dubbio il 2010.
                    </div>

                    <div class="howto-title2">Notevoli produttori piemontesi:</div>
                    <div class="howto-text">
                        Mentre non esiste una formula infallibile per dire se investire in vini veneti, toscani o piemontesi
                        (o anche le regioni minori) faranno la tua fortuna, rendimenti bassi come nei produttori notevoli
                        spesso vanno di pari passo con prezzi alle stelle. Produttori come Gaja, Bruno Giacosa, Giacomo
                        Conterno, e Poderi Aldo Conterno come investimenti sicuri. Chiedi sempre al tuo rivenditore
                        per una consulenza prima di prendere qualsiasi decisione di investimento.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Piedmont</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Wenn man über italienische Rotweine und ihre Anbaugebiete spricht, kommt man nicht umhin
                        Erwähnen Sie Piemont. Nur einen Steinwurf von der französischen Grenze entfernt liegt die Region Piemont am Fuße der Alpen und produziert Weine von großer Güte; sowohl körperreich als auch herrlich parfümiert. Die Hauptanbaugebiete sind natürlich Barolo und Barbaresco sowie die Königstraube
                        Hier ist zweifellos Nebbiolo. Einige Weißweine, insbesondere der immer modischer werdende Gavi (hergestellt
                        mit Cortese-Trauben) machen den Rotweinen Konkurrenz. Erkennen, dass die Leute es wollten
                        Weine zur Lagerung und Investition (sowie zum sofortigen Trinken), die viele Barolo-Winzer hergestellt haben
                        die Umstellung auf die Reifung in französischen Eichenfässern. Dadurch erhöhte sich die Lagerfähigkeit bei manchen auf etwa 20 Jahre
                        Weine höchster Qualität. Eine weitere Veränderung, die Weine aus dem Piemont erlebt haben, ist die allmähliche Abkehr von
                        100 % Einzelwein bis zum Verschnitt; Es ist nicht ungewöhnlich, Nebbiolo mit Barbera vermischt zu finden.
                        Merlot, Cabernet oder sogar Syrah.
                        <br><br>
                        Obwohl oft in einen Topf geworfen, weisen Barolo und Barbaresco große Unterschiede auf. Barolo, der
                        Der sogenannte „Wein der Könige und König der Weine“ ist ein großartiges Weintier. Bringt das Gewicht von 150
                        Barolo Riservas haben eine jahrelange Geschichte und benötigen mindestens fünf Jahre im Holz und in der Flasche
                        vor der Veröffentlichung sind sie samtig glatt und dennoch überraschend mager und gehören wahrscheinlich zu den berühmtesten Italiens
                        Export. Barbaresco hingegen ist leichter und reift früher (nur vier Jahre im Fass).
                        oder Botti vor der Veröffentlichung) und etwas leichter im Glas. Weil beide Regionen so nah beieinander liegen
                        In der Nähe ist die Bodentopographie sehr ähnlich. Beide produzieren seitdem hervorragende Jahrgänge
                        In den späten 1990ern und 2002 ist fast jeder ein Gewinner. Wenn wir unseren Favoriten auswählen müssten
                        Es wäre jedoch zweifellos das Jahr 2010.
                    </div>

                    <div class="howto-title2">Bemerkenswerte Produzenten im Piemont:</div>
                    <div class="howto-text">
                        Es gibt zwar keine narrensichere Formel, um zu sagen, ob man in Weine aus Venetien, der Toskana oder dem Piemont investiert
                        (oder sogar die kleineren Regionen) werden Ihr Glück machen, niedrige Erträge wie bei den namhaften Produzenten
                        gehen oft mit explodierenden Preisen einher. Produzenten wie Gaja, Bruno Giacosa, Giacomo
                        Conterno und Poderi Aldo Conterno gelten als sichere Anlagen. Bitte fragen Sie immer Ihren Händler
                        Bitten Sie uns um Rat, bevor Sie eine Anlageentscheidung treffen.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Piedmont</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Lorsqu'on parle des vins rouges italiens et de leurs régions de production, il serait impossible de ne pas
                        mentionner le Piémont. A deux pas de la frontière française, la région du Piémont se trouve au pied des Alpes et produit des vins de grande gourmandise ; à la fois corsé et superbement parfumé. Les principales régions sont bien sûr Barolo et Barbaresco et le cépage roi
                        voici sans aucun doute Nebbiolo. Certains Blancs, notamment le Gavi de plus en plus en vogue (fabriqué
                        avec des raisins Cortese) donnent du fil à retordre aux rouges. Réalisant que les gens voulaient
                        vins de garde et d'investissement (ainsi qu'à boire immédiatement), de nombreux vignerons Barolo ont fait
                        le passage au vieillissement en fûts de chêne français. Cela a poussé la garde à environ 20 ans pour certains
                        des vins de la plus haute qualité. Un autre changement que les vins du Piémont ont connu est le passage progressif de
                        100% mono vignoble à assemblage ; il n'est pas rare de trouver du Nebbiolo mélangé à du Barbera,
                        Merlot, Cabernet ou encore Syrah.
                        <br><br>
                        Bien que souvent regroupés, Barolo et Barbaresco présentent de grandes différences. Barolo, le
                        soi-disant "vin des rois et roi des vins" est une grande bête de vin. Apporter le poids de 150
                        ans d'histoire avec elle, Barolo Riservas nécessitent un minimum de cinq ans en bois et en bouteille
                        avant leur sortie, sont veloutés mais étonnamment maigres et sont probablement les plus célèbres d'Italie
                        exporter. Barbaresco, en revanche, est plus léger, plus précoce à mûrir (seulement quatre ans en barrique
                        ou botti avant la sortie) et un peu plus facile dans le verre. Parce que les deux régions sont si proches
                        proximité, la topographie des sols est très similaire. Tous deux produisent d'excellents millésimes depuis
                        la fin des années 1990 et bar, 2002, presque tout le monde est gagnant. Si nous devions choisir notre préféré
                        cependant ce serait sans doute 2010.
                    </div>

                    <div class="howto-title2">Producteurs notables du Piémont:</div>
                    <div class="howto-text">
                        S'il n'y a pas de formule infaillible pour dire s'il faut investir dans des vins de Vénétie, de Toscane ou du Piémont
                        (ou même les petites régions) feront votre fortune, les faibles rendements comme chez les producteurs notables
                        vont souvent de pair avec une flambée des prix. Des producteurs tels que Gaja, Bruno Giacosa, Giacomo
                        Conterno et Poderi Aldo Conterno comme des placements sûrs. Veuillez toujours demander à votre revendeur
                        pour obtenir des conseils avant de prendre toute décision d'investissement.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Piedmont</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        When talking about Italian red wines and their growing regions, it would be impossible not to
                        mention Piedmont. A stone’s throw from the French border, the Piedmont region is found at the foot of the Alps and produces wines of great gusto; both big bodied and superbly perfumed. The main regions are of course Barolo and Barbaresco and the king grape
                        here is undoubtedly Nebbiolo. Some whites, particularly the increasingly fashionable Gavi (made
                        with Cortese grapes) are giving the reds a run for their money. Realising that people wanted
                        wines for cellaring and investment (as well as immediate drinking), many Barolo winemakers made
                        the switch to ageing in French oak barrels. This pushed ageability to around 20 years for some
                        of the highest quality wines. Another change wines of Piemonte has seen is the gradual move from
                        100% single vineyard to blending; it is not uncommon to find Nebbiolo blended with Barbera,
                        Merlot, Cabernet or even Syrah.
                        <br><br>
                        Although often lumped together, Barolo and Barbaresco show great differences. Barolo, the
                        so-called “wine of kings and king of wines” is a great beast of a wine. Bringing the heft of 150
                        years of history with it, Barolo Riservas require a minimum of five years in wood and bottle
                        before release, are velvety smooth yet surprisingly lean and are probably Italy’s most famous
                        export. Barbaresco, on the other hand, is lighter, earlier to mature (just four years in barrel
                        or botti prior to release) and a bit easier in the glass. Because both regions are so close in
                        proximity, soil topography is very similar. Both have been producing excellent vintages since
                        the late 1990s and bar, 2002, almost every one is a winner. If we had to pick our favourite
                        however it would no doubt be 2010.
                    </div>

                    <div class="howto-title2">Notable producers of Piedmont:</div>
                    <div class="howto-text">
                        While there is no foolproof formula to say whether investing in Veneto, Tuscan or Piedmont wines
                        (or even the lesser regions) will make your fortune, low yields such as in the notable producers
                        often go hand in hand with skyrocketing prices. Producers such as Gaja, Bruno Giacosa, Giacomo
                        Conterno, and Poderi Aldo Conterno as considered safe investments. Please always ask your dealer
                        for advice prior to making any investment decision.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Pedmont",
    data() {
        return {
            select: {report: 'Please choose', src: '#'},
            items: [
                {report: 'Bruno Giacosa', src: '/wine-guide/italy/piedmont/bruno-giacosa'},
                {report: 'Cantina Roberto Voerzio', src: '/wine-guide/italy/piedmont/cantina-roberto-voerzio'},
                {report: 'Conterno Fantino', src: '/wine-guide/italy/piedmont/conterno-fantino'},
                {report: 'G. D. Vajra', src: '/wine-guide/italy/piedmont/g-d-vajra'},
                {report: 'Gaja', src: '/wine-guide/italy/piedmont/gaja'},
                {report: 'Giacomo Conterno', src: '/wine-guide/italy/piedmont/giacomo-conterno'},
                {
                    report: 'Giuseppe Mascarello e Figlio',
                    src: '/wine-guide/italy/piedmont/giuseppe-mascarello-e-figlio'
                },
                {report: 'Massolino', src: '/wine-guide/italy/piedmont/massolino'},
                {report: 'Poderi Aldo Conterno', src: '/wine-guide/italy/piedmont/poderi-aldo-conterno'},
                {report: 'Roagna', src: '/wine-guide/italy/piedmont/roagna'},
                {report: 'Tenuta La Giustiniana', src: '/wine-guide/italy/piedmont/tenuta-la-giustiniana'},
                {report: 'Vigne Marina Coppi', src: '/wine-guide/italy/piedmont/vigne-marina-coppi'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    },
    head: {
        title: 'Piedmont | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the rich history and renowned wines of the Piedmont wine region in Italy. From Barolo to Barbera, explore the diverse range of flavors and styles produced by the winemakers of Piedmont.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
